const TO_CPF = value => {
  return value ? `${value.slice(0, 3)}.${value.slice(3, 6)}.${value.slice(6, 9)}-${value.slice(9, 11)}` : value;
}


export default {
  TO_CPF
};
